import { render, staticRenderFns } from "./VehicleDetail.vue?vue&type=template&id=c9cf35b4&scoped=true&"
import script from "./VehicleDetail.vue?vue&type=script&lang=js&"
export * from "./VehicleDetail.vue?vue&type=script&lang=js&"
import style0 from "./VehicleDetail.vue?vue&type=style&index=0&id=c9cf35b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cf35b4",
  null
  
)

export default component.exports